import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { SpeedInsights } from '@vercel/speed-insights/react'; // Import SpeedInsights
import { Analytics } from "@vercel/analytics/react"

import Home from './pages/Home';
import Navbar from './pages/Navbar';
import Footer from './pages/Footer';
import About from './pages/About';
import Terms from './pages/Terms';

import VideoPage from './components/navigation/learning/VideoPage'; // VideoPage handles Videos and VideoPlayer
import Podcasts from './components/navigation/learning/Podcasts';
import PodcastPlayer from './components/navigation/learning/PodcastPlayer';
import VideoPlayer from './components/navigation/learning/VideoPlayer'; // Import VideoPlayer
import VideoDetails from './components/navigation/learning/VideoDetails';
import Gamified from './components/navigation/learning/Gamified';

import FAQ from './components/navigation/learning/Faqs';

import CIA from './components/navigation/certifications/CIA';

import AuditFrameworks from './components/navigation/resources/AuditFrameworks';
import AuditTemplates from './components/navigation/resources/AuditTemplates';
import Workprograms from './components/navigation/resources/Workprograms';
import RiskMatrix from './components/navigation/resources/RiskMatrix';

import RiskLibrary from './components/navigation/resources/RiskLibrary';
import JobDescriptions from './components/navigation/resources/JobDescriptions';
import GuidedToolkit from './components/navigation/resources/guided/GuidedToolkit';

import Fraud from './components/navigation/blog/Fraud';

import Dashboard from './components/navigation/continuousauditing/Dashboard';
import DepartmentsPage from './components/navigation/continuousauditing/DepartmentsPage';
import FinanceProcessPage from './components/navigation/continuousauditing/FinanceProcessPage';
import ProcurementProcessPage from './components/navigation/continuousauditing/ProcurementProcessPage';

import SampleGenerator from './components/navigation/automation/SampleGenerator';
import CardGenerator from './components/navigation/automation/CardGenerator';

import ChatbotInterface from './components/navigation/aitools/ChatbotInterface';

import Blog from './components/navigation/blog/Blog';

function App() {
  const [currentPodcast, setCurrentPodcast] = useState(null); // Currently selected podcast
  const [playlist, setPlaylist] = useState([]); // Playlist for the PodcastPlayer

  const [currentVideo, setCurrentVideo] = useState(null); // Currently selected video

  // Function to play a podcast
  const playPodcast = (podcast) => {
    setCurrentPodcast(podcast);
    setPlaylist([podcast]); // Set the selected podcast as the playlist
  };

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        {/* Navbar */}
        <Navbar />

        {/* Main Content */}
        <div className="flex-grow">
          <Routes>
            {/* Home Page */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/terms" element={<Terms />} />

            {/* Video Page */}
            <Route
              path="/videos"
              element={<VideoPage currentVideo={currentVideo} setCurrentVideo={setCurrentVideo} />}
            />
            <Route path="/videos/:slug" element={<VideoDetails />} />


            {/* Podcast Page */}
            <Route
              path="/podcasts"
              element={<Podcasts playPodcast={playPodcast} currentPodcast={currentPodcast} />}
            />
            <Route path="/podcasts/:slug" element={<Podcasts playPodcast={playPodcast} />} />


            {/* Audit Game Page */}
            <Route path="/gamified-learning" element={<Gamified />} />

            {/* FAQ Page */}
            <Route path="/faqs" element={<FAQ />} />

            {/* Certification Pages */}
            <Route path="/certifications/cia" element={<CIA />} />

            {/* Resources Pages */}
            <Route path="/resources/audit-frameworks" element={<AuditFrameworks />} />
            <Route path="/resources/audit-templates" element={<AuditTemplates />} />
            <Route path="/resources/workprograms" element={<Workprograms />} />
            <Route path="/resources/risk-matrix" element={<RiskMatrix />} />

            <Route path="/resources/risk-library" element={<RiskLibrary />} />
            <Route path="/resources/job-descriptions" element={<JobDescriptions />} />
            <Route path="/resources/guided-toolkit" element={<GuidedToolkit />} />

            {/* Continuous Auditing */}
            <Route path="/continuous" element={<Dashboard />} />
            <Route path="/departments" element={<DepartmentsPage />} />
            <Route path="/finance" element={<FinanceProcessPage />} />
            <Route path="/procurement" element={<ProcurementProcessPage />} />


            {/* AI Tools */}
            <Route path="/blog/fraud" element={<Fraud/>} />

            {/* Automation Tools */}
            <Route path="/automation-tools/sample-generator" element={<SampleGenerator />} />
            <Route path="/automation-tools/card-generator" element={<CardGenerator />} />

            <Route path="/aitools/chatbot" element={<ChatbotInterface />} />

{/* Blog Page */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<Blog />} />
            



          </Routes>
        </div>

        {/* Global Podcast Player */}
        {currentPodcast && (
          <div className="fixed bottom-0 w-full bg-gray-100 border-t">
            <PodcastPlayer playlist={playlist} currentPodcast={currentPodcast} />
          </div>
        )}

        {/* Global Video Player */}
        {currentVideo && (
          <div className="fixed bottom-0 w-full bg-gray-100 border-t">
            <VideoPlayer currentVideo={currentVideo} />
          </div>
        )}

        {/* Footer */}
        <Footer />

        {/* Speed Insights Component */}
        <SpeedInsights />
 {/* Web Analytics */}
        <Analytics />

      </div>
    </Router>
  );
}

export default App;
